import { __module as rangePropType } from '../../../../../_virtual/range-prop-type.js';
import { __require as requireUtils } from '../utils/index.js';

var hasRequiredRangePropType;

function requireRangePropType () {
	if (hasRequiredRangePropType) return rangePropType.exports;
	hasRequiredRangePropType = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = rangePropType;

		var _utils = requireUtils();

		/**
		 * @ignore
		 * @param {Object} props - React component props
		 * @return {?Error} Return Error if validation fails
		 */
		function rangePropType(props) {
		  var maxValue = props.maxValue,
		      minValue = props.minValue;


		  if (!(0, _utils.isNumber)(minValue) || !(0, _utils.isNumber)(maxValue)) {
		    return new Error('"minValue" and "maxValue" must be a number');
		  }

		  if (minValue >= maxValue) {
		    return new Error('"minValue" must be smaller than "maxValue"');
		  }
		}
		module.exports = exports['default'];
		
	} (rangePropType, rangePropType.exports));
	return rangePropType.exports;
}

export { requireRangePropType as __require };
